import apiClient from '@/services/rest-api-vsms/apiClient'

const baseEndpoint = '/system-notification'

export const get = async (id) => {
  const response = await apiClient({
    method: 'GET',
    url: `${baseEndpoint}/${id}`,
  })

  return response?.data
}
